
import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { MergeLogsRoutes  } from '../../../routes';

export const MergeLogLayout = () => <SwitchRoute routes={MergeLogsRoutes} />;
